import MinerSupplyUI from './MinerSupplyUI';
import { WalletContextProvider } from './contexts/WalletContext';
import { MiningProvider } from './contexts/MiningContext';

/**
 * App Component - Root application wrapper
 *
 * Wraps the application with necessary providers:
 * - WalletContextProvider: Handles Solana wallet connection
 * - MiningProvider: Handles mining simulation and state
 *
 * Additional providers can be added here as needed while
 * maintaining separation of concerns.
 */
function App() {
  return (
    <WalletContextProvider>
      <MiningProvider>
        <MinerSupplyUI />
      </MiningProvider>
    </WalletContextProvider>
  );
}

export default App;